import { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { SbSharedWordpressArticlesWrapper } from '../SbSharedWordpressArticles/SbSharedWordpressArticlesWrapper';
import { SbRespInteriorsModule } from './SbRespInteriorsModule';
import { showInteriorsModule } from '../SbSharedInteriorsModule/interiorsModuleHelpers';

import { SbRespInteriorsWordpressArticlesWrapper_itemSearch } from './__generated__/SbRespInteriorsWordpressArticlesWrapper_itemSearch.graphql';
import { SbRespInteriorsWordpressArticlesWrapper_viewer } from './__generated__/SbRespInteriorsWordpressArticlesWrapper_viewer.graphql';

type Props = {
    itemSearch: SbRespInteriorsWordpressArticlesWrapper_itemSearch;
    viewer: SbRespInteriorsWordpressArticlesWrapper_viewer;
};

const SbRespInteriorsWordpressArticlesWrapperComponent: FC<Props> = props => {
    const { itemSearch, viewer } = props;
    const editorial = itemSearch.editorial;

    if (showInteriorsModule(itemSearch.interiorPhotos?.photos)) {
        return <SbRespInteriorsModule editorial={editorial} itemSearch={itemSearch} />;
    } else {
        return <SbSharedWordpressArticlesWrapper editorial={editorial} viewer={viewer} />;
    }
};

export const SbRespInteriorsWordpressArticlesWrapper = createFragmentContainer(
    SbRespInteriorsWordpressArticlesWrapperComponent,
    {
        viewer: graphql`
            fragment SbRespInteriorsWordpressArticlesWrapper_viewer on Viewer {
                ...SbSharedWordpressArticlesWrapper_viewer
            }
        `,
        itemSearch: graphql`
            fragment SbRespInteriorsWordpressArticlesWrapper_itemSearch on ItemSearchQueryConnection {
                ...SbRespInteriorsModule_itemSearch
                editorial: editorialArticles(first: 3) {
                    ...SbRespInteriorsModule_editorial
                    ...SbSharedWordpressArticlesWrapper_editorial
                }
                interiorPhotos {
                    photos {
                        serviceId
                    }
                }
            }
        `,
    }
);
